import React from 'react';
import { Tooltip } from '@branchjs/neo-components';
import { ImageService } from '../../../services/ImageService/ImageService';
import { LockedPackagingIconStyles } from './LockedPackagingIcon.styles';

const LockedPackagingIcon = () => {
  return (
    <Tooltip
      title={
        <span>
          <a>Explore plans and add-ons</a>
          <br />
          to unlock more of Branch
        </span>
      }
      placement="right"
    >
      <img
        className="tooltip-icon"
        style={LockedPackagingIconStyles.image}
        src={ImageService.getImageUrl('/static/images/navigation/lightning-circle.svg')}
        alt="Locked"
        onClick={(e) => e.stopPropagation()}
      />
    </Tooltip>
  );
};

export default LockedPackagingIcon;
